import { defineStyleConfig } from '@chakra-ui/react';

export const linkRecipe = defineStyleConfig({
  baseStyle: {
    _hover: {
      textDecoration: 'none',
    },
  },
});
